"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var main_1 = require("../../../../main");
var react_1 = require("react");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.navButton = function (direction, unit) {
            var _a = _this.props, next = _a.next, previous = _a.previous;
            var onClick = direction === 'right' ? function () { return next(unit); } : function () { return previous(unit); };
            var name = unit === 'month' ? "caret-" + direction : "double-caret-" + direction;
            return (React.createElement("div", { className: "cal-nav-btn next-btn", onClick: onClick },
                React.createElement(main_1.Icon, { root: "common", className: "cal-nav-icon", name: name })));
        };
        return _this;
    }
    Header.prototype.render = function () {
        var _a = this.props, years = _a.years, month = _a.month, range = _a.range;
        return (React.createElement("header", { className: "header" },
            React.createElement("div", { className: "month-display cal-row" },
                years && this.navButton('left', 'year'),
                this.navButton('left', 'month'),
                React.createElement("div", { className: "month-label" }, month.format('MMMM YYYY')),
                range && React.createElement("div", { className: "month-label" }, month.clone().add(1, 'month').format('MMMM YYYY')),
                this.navButton('right', 'month'),
                years && this.navButton('right', 'year'))));
    };
    return Header;
}(react_1.Component));
exports.default = Header;
